export const convertProductNameToUrl = (input: string) => {
  const decodedInput = decodeURIComponent(input);
  const urlFormat = decodedInput
    ?.toLowerCase()
    ?.normalize('NFKD')
    ?.replace(/\s+/g, '-')
    ?.replace(/&/g, 'and')
    ?.replace(/[^\w-.]/g, '')
    ?.replace(/--+/g, '--');

  return urlFormat?.endsWith('-') ? urlFormat?.slice(0, -1) : urlFormat;
};

export const productNameToMetaTitle = (input: string) => {
  const urlFormat = input
    ?.toLowerCase()
    ?.replace(/&/g, 'and')
    ?.replace(/'/g, '')
    ?.replace(/,/g, '')
    ?.replace(/[“”"‘’]/g, '');
  const decoded = decodeURIComponent(urlFormat);
  const titleCase = decoded
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  return titleCase;
};

export const convertProductNameToMetaData = (input: string) => {
  const urlFormat = input
    ?.toLowerCase()
    ?.replace(/\s+/g, '-')
    ?.replace(/&/g, 'and')
    ?.replace(/'/g, '')
    ?.replace(/,/g, '')
    ?.replace(/[“”"‘’]/g, '');

  return urlFormat?.endsWith('-') ? urlFormat : `${urlFormat}-`;
};

export const removeSpecialQuotes = (input: string) => {
  const decoded = decodeURIComponent(input);
  return decoded.replace(/[“”"‘’]/g, '');
};
